import React from 'react';
import {Chip, Link, Stack, StackProps, Typography, TypographyProps} from "@mui/material";
import {CheckRounded, CloseRounded} from '@mui/icons-material';

export interface DataWithLabelProps {
    label: React.ReactNode,
    data: React.ReactNode,
    labelProps?: TypographyProps,
    dataProps?: TypographyProps,
    rowDirection?: boolean
    rowProps?: StackProps,
    type?: 'string' | 'icon',
    fullWidth?: boolean,
    mediumWidth?: boolean,
    link?: boolean,
    onClick?: () => void,
    check?: boolean
}

function DataWithLabel({label, data, type, labelProps, dataProps, rowDirection, rowProps, fullWidth, mediumWidth, link, onClick}: DataWithLabelProps) {
    const dataToRender = type !== 'icon' ? data ? data : <Typography color={'secondary !important'} fontStyle={'italic'} fontWeight={600}> - </Typography> :
        data ?
            <Chip label="Sí"
                  size="small"
                  color="success"
                  icon={<CheckRounded  />}
            /> :
            <Chip label="No"
                  size="small"
                  color="error"
                  icon={<CloseRounded  />}
            />

    const justifyContent = (fullWidth || mediumWidth) ? 'space-between' : rowProps?.justifyContent;
    const labelWidth = fullWidth ? 1 : mediumWidth ? 0.5 : undefined

    return (
        <Stack justifyContent={justifyContent}
               direction={rowDirection ? "row" : "column"}
               alignItems={"flex-start"}
               spacing={rowDirection ? 1 : 0}
               gap={fullWidth ? 8 : undefined}
               ml={fullWidth ? 1 : undefined}
               {...rowProps}
        >
            <Typography variant='caption'
                        color="text.disabled"
                        fontWeight={500}
                        fontSize="1rem"
                        width={labelWidth}
                        {...labelProps}
            >
                {(rowDirection && !fullWidth && !mediumWidth) ? `${label}: ` : label}
            </Typography>
            <Typography component='span'
                        fontWeight={600}
                        width={(fullWidth || mediumWidth) ? 1 : undefined}
                        {...dataProps}
            >
                {(link && onClick) ?
                    <Link component={"button"} onClick={onClick} underline={"none"} target={"_blank"}>
                        {dataToRender}
                    </Link>
                    :
                    dataToRender
                }
            </Typography>
        </Stack>
    );
}

function DataWithLabelColorEditableData({label, data, labelProps, dataProps, rowDirection, rowProps}: DataWithLabelProps) {

    return (
        rowDirection ?
            <Stack direction="row"
                   alignItems="center"
                   {...rowProps}
            >
                <Typography variant='caption'
                            {...labelProps}>
                    {label}:

                </Typography>
                <Typography
                    variant='h6'
                    sx={{ marginLeft: '12px' }}
                    {...dataProps}>
                    {data}
                </Typography>
            </Stack>

            :

            <Typography variant='caption'
                        {...labelProps}>
                {label}
                <Typography mt={-1}
                            variant='h6'
                            {...dataProps}>
                    {data}
                </Typography>
            </Typography>

    );
}

function DataWithLabelPrimary({label, data, labelProps, dataProps, rowDirection}: DataWithLabelProps) {

    return (
        rowDirection ?
            <Stack direction="row"
                   alignItems="center">
                <Typography variant='caption'
                            {...labelProps}>
                    {label}:

                </Typography>
                <Typography
                    variant='h6'
                    sx={{ marginLeft: '12px' }}
                    {...dataProps}>
                    {data}
                </Typography>
            </Stack>

            :

            <Typography variant='caption'
                        {...labelProps}>
                {label}
                <Typography
                    variant='h6'
                    {...dataProps}>
                    {data}
                </Typography>
            </Typography>
    );
}

interface DataWithLabelCompanyFileProps {
    label: string,
    data?: any
}

function DataWithLabelCompanyFile({label, data}: DataWithLabelCompanyFileProps) {
    const dataRender = data ?
        <Typography fontWeight={600} fontSize={'1.1rem'}>{data}</Typography>
        :
        <Typography fontStyle={'italic'} color={'#eac276 !important'} fontWeight={600}>Pendiente de carga</Typography>;

    return (
        <DataWithLabel label={label}
                       data={dataRender}
                       rowDirection
                       mediumWidth
        />
    )
}

// @ts-ignore
interface DataWithLabelCheckProps extends DataWithLabelProps {
    data?: React.ReactNode | boolean
}

function DataWithLabelCheck({data, ...props}: DataWithLabelCheckProps) {

    const stylesIcon = {
        fontSize: '18px', paddingTop: '4px'
    }

    return (
        <DataWithLabel {...props}
                       data={
                           data ?
                               <CheckRounded sx={stylesIcon} /> :
                               <CloseRounded sx={stylesIcon} />}
        />

    );
}

export {
    DataWithLabel,
    DataWithLabelColorEditableData,
    DataWithLabelPrimary,
    DataWithLabelCompanyFile,
    DataWithLabelCheck
};